import React, { useEffect, useState, useRef } from 'react';
const purchases = [{
  name: 'Valentina M.',
  city: 'Buenos Aires',
  initials: 'VM',
  product: 'Megapack Psicología Carrera Resuelta',
  time: 'hace 2 min'
}, {
  name: 'Lucía R.',
  city: 'Córdoba',
  initials: 'LR',
  product: 'Megapack + Máster Psicología',
  time: 'hace 4 min'
}, {
  name: 'Camila S.',
  city: 'Rosario',
  initials: 'CS',
  product: 'Megapack Psicología Carrera Resuelta',
  time: 'hace 7 min'
}, {
  name: 'Sofía G.',
  city: 'La Plata',
  initials: 'SG',
  product: 'Megapack + Máster Psicología',
  time: 'hace 10 min'
}, {
  name: 'Martina P.',
  city: 'Mendoza',
  initials: 'MP',
  product: 'Megapack Psicología Carrera Resuelta',
  time: 'hace 13 min'
}, {
  name: 'Julieta F.',
  city: 'Tucumán',
  initials: 'JF',
  product: 'Megapack + Máster Psicología',
  time: 'hace 16 min'
}, {
  name: 'Florencia B.',
  city: 'Santa Fe',
  initials: 'FB',
  product: 'Megapack Psicología Carrera Resuelta',
  time: 'hace 19 min'
}, {
  name: 'Agustina L.',
  city: 'Mar del Plata',
  initials: 'AL',
  product: 'Megapack + Máster Psicología',
  time: 'hace 23 min'
}, {
  name: 'Rocío T.',
  city: 'Salta',
  initials: 'RT',
  product: 'Megapack Psicología Carrera Resuelta',
  time: 'hace 27 min'
}, {
  name: 'Milagros C.',
  city: 'San Juan',
  initials: 'MC',
  product: 'Megapack + Máster Psicología',
  time: 'hace 31 min'
}, {
  name: 'Daniela V.',
  city: 'Neuquén',
  initials: 'DV',
  product: 'Megapack Psicología Carrera Resuelta',
  time: 'hace 35 min'
}, {
  name: 'Natalia H.',
  city: 'Paraná',
  initials: 'NH',
  product: 'Megapack + Máster Psicología',
  time: 'hace 40 min'
}];
const avatarColors: Record<string, string> = {
  VM: '#B8860B',
  LR: '#7A9E7E',
  CS: '#C8922A',
  SG: '#6B4C35',
  MP: '#9A7B5A',
  JF: '#B8860B',
  FB: '#7A9E7E',
  AL: '#C8922A',
  RT: '#6B4C35',
  MC: '#B8860B',
  DV: '#9A7B5A',
  NH: '#7A9E7E'
};
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  const indexRef = useRef(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    function showNext() {
      setCurrent(indexRef.current);
      setVisible(true);
      timeoutRef.current = setTimeout(() => {
        setVisible(false);
        indexRef.current = (indexRef.current + 1) % purchases.length;
        const nextDelay = 12000 + Math.random() * 6000;
        timeoutRef.current = setTimeout(showNext, nextDelay);
      }, 4000);
    }
    timeoutRef.current = setTimeout(showNext, 8000);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  const purchase = current !== null ? purchases[current] : null;
  if (!purchase) return null;
  const bgColor = avatarColors[purchase.initials] || '#C8922A';
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs" style={{
    animation: visible ? 'notifIn 0.3s ease-out forwards' : 'notifOut 0.3s ease-in forwards',
    pointerEvents: 'none'
  }} data-id="element-284">
      <div className="flex items-center gap-3 rounded-xl shadow-lg px-4 py-3" style={{
      backgroundColor: '#ffffff',
      border: '1px solid rgba(200,146,42,0.28)'
    }} data-id="element-285">
        {/* Avatar */}
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-black text-white" style={{
        backgroundColor: bgColor
      }} data-id="element-286">
          {purchase.initials}
        </div>

        {/* Text */}
        <div className="min-w-0" data-id="element-287">
          <p className="text-xs font-bold m-0 truncate" style={{
          color: '#1E1208'
        }} data-id="element-288">
            {purchase.name} — {purchase.city}
          </p>
          <p className="text-[10px] m-0 truncate" style={{
          color: '#9A7B5A'
        }} data-id="element-289">
            Acaba de obtener {purchase.product}
          </p>
          <p className="text-[10px] font-semibold m-0" style={{
          color: '#7A9E7E'
        }} data-id="element-290">
            ✓ {purchase.time}
          </p>
        </div>
      </div>
    </div>;
}